import { useCallback } from 'react';
import { DivProps } from 'typings';
import UDText from 'ud-ui/components/text';
import { BoardsList as MainBlock, Header, List } from './styles';

interface IProps {
  headerText: string;
  headerProps?: DivProps;
  items: JSX.Element[];
}

function BoardsList(props: IProps) {
  const { headerText, headerProps, items } = props;

  const onScroll = useCallback(() => {
    const newEvent = new Event('scrollBoardsList');
    window.dispatchEvent(newEvent);
  }, []);

  return (
    <MainBlock id={'boardsList'}>
      <Header {...headerProps}>
        <UDText type={'subhead'} style={{ fontSize: 'inherit', color: 'inherit' }}>
          {headerText}
        </UDText>
      </Header>
      <List onScroll={onScroll}>{items}</List>
    </MainBlock>
  );
}

export default BoardsList;
